<template>
  <div class="newDataPage">
    <div class="steps">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    </div>
    <div class="steps-content">
      <template v-if="current == 0">
        <new-customer @setFactory="setFactory" :customerInfo="customerInfo" ref="newCustomer"/>
      </template>
      <template v-if="current == 1">
        <new-feed-info 
          ref="newFeedInfo"
          @setFeedInfo="setFeedInfo" 
          :selectFactory="selectFactory" 
          :factoryId="factoryId"
          :feedInfoList="feedInfoList"
          :pigLineRaiseInfos="pigLineRaiseInfos"
          :pigLineFeedInfo="pigLineFeedInfo"
        />
      </template>
      <template v-if="current == 2">
        <new-customer-feedback 
          ref="newCustomerFeedback" 
          @setFeedBack="setFeedBack" 
          :pigLineFeedBackReq="pigLineFeedBackReq"
          @setFileList="setFileList"
          :fileListProp="{fileList,videoFileList}"
        />
      </template>
      <template v-if="current ==3">
        <new-finish 
          :returnList="returnList" 
          :saveSuccess="saveSuccess" 
          :recordId="recordId"
          @saveData="'saveData'"
        />
      </template>
    </div>
    <div class="footer">
      <a-button v-if="current > 0 && current < steps.length-1" @click="prev">上一步</a-button>
      <a-button v-if="current == 0" @click="returnList">取 消</a-button>
      <a-button v-if="current < steps.length - 2" type="primary" @click="next" style="margin-left: 10px">下一步</a-button>
      <a-button v-if="current == 2" type="primary" @click="next" style="margin-left: 10px">提 交</a-button>
    </div>
    <calculation-result-modal 
      :visible="visible" 
      @isShow="isShow"
      :calculationResult="calculationResult"
      :calculationAbnormal="calculationAbnormal"
      @calculationAbnormalInit="calculationAbnormalInit"
      @calculationConfirm="calculationConfirm"
    />
  </div>
</template>
<script>
import NewCustomer from './PigNewDataComponents/NewCustomer.vue';
import NewCustomerFeedback from './PigNewDataComponents/NewCustomerFeedback.vue';
import NewFeedInfo from './PigNewDataComponents/NewFeedInfo.vue';
import NewFinish from './PigNewDataComponents/NewFinish.vue';
import CalculationResultModal from './PigNewDataComponents/CalculationResultModal.vue'
import api from '../EmpiricalData/api'
const stagesLimitations = [
	{min: 0,max: 8,field: 'PIGLET',title: '教槽',index: 0},
	{min: 8,max: 12,field: 'CHILDCARE_BEFORE',title: '保育前期',index: 1},
	{min: 12,max: 25,field: 'CHILDCARE_AFTER',title: '保育后期',index: 2},
	{min: 25,max: 50,field: 'LITTLE_PIG',title: '仔猪',index: 3},
	{min: 50,max: 75,field: 'MEDIUM',title: '生长猪',index: 4},
	{min: 75,max: 100,field: 'FATTENING_PIG',title: '育肥猪',index: 5},
	{min: 100,max: 1000,field: 'LARGE_PIG',title: '大猪',index: 6},
]
export default {
  components: { NewCustomer, NewFeedInfo, NewCustomerFeedback, NewFinish, CalculationResultModal},
  data() {
    return {
      current: 0,
      steps: [
        {title: '填写客户信息'},
        {title: '填写饲养信息'},
        {title: '填写客户反馈'},
        {title: '完成'},
      ],
      selectFactory:'',
      factoryId:'',
      customerInfo:{},
      feedInfoList:[{
        state: '入栏',
        day: '',
        dayAge: '',
        weight: '',
        num:''
      },{
        state: '出栏',
        day: '',
        dayAge: '',
        weight: '',
        num:''
      }],
      feedStageList:[],
      pigLineFeedBackReq:{},
      visible:false,
      pigLineFeedInfo:{},
      pigLineRaiseInfos:[],
      calculationResult:{},
      calculationAbnormal:[],
      settlementId:'',
      saveSuccess:false,
      recordId:'',
      fileList:[],
      videoFileList:[],
      stagesLimitations,
      stages2:[],
      stagesCode:[],
      Tipsmsg:'',
      flag1 : false,
      flag2 : false,
      msg1 :'',
      msg2 : ''
    };
  },
  mounted(){
    if(this.$route.query.copyId) this.copyValues()
  },
  methods: {
    async copyValues(){
      let {copyId} = this.$route.query
      let params = {
        recordId: copyId,
        lineType: 'PIG_LINE'
      }
      let res = await api.pigDetail(params)
      if(!res.success) this.$message.error(res.msg) 
      this.pigLineFeedInfo = res?.data?.pigLineFeedInfo || {}
      this.customerInfo = res?.data?.pigLineCustomerInfo || {}
      this.customerInfo.region = this.customerInfo.province&&this.customerInfo.city&&this.customerInfo.area ?
       [this.customerInfo.province,this.customerInfo.city,this.customerInfo.area] : undefined
      this.pigLineRaiseInfos = res?.data?.pigLineRaiseInfos || []
      if(!(this.customerInfo.createUser == window.localStorage.getItem('staffId')) && this.pigLineFeedInfo.feedBrand == '新希望'){this.pigLineRaiseInfos = []}
      this.calculationResult = res?.data?.calculationResult || {}
      this.pigLineFeedBackReq = res?.data?.pigLineFeedBackReq || {}
      this.loadFiles()
    },
    next() {
      if(this.current == 0){
        this.$refs.newCustomer.form.validateFields((err, values) => {
          if (!err) {
            this.customerInfo = values
            this.current++;
          }
        })
      }
      else if(this.current == 1){
        this.$refs.newFeedInfo.form.validateFields((err, values) => {
          if (!err) {
            this.Tipsmsg = ''
            this.pigLineFeedInfo = values
            this.$refs.newFeedInfo.sendData()
            this.feedCheck()
            if(!this.Tipsmsg) {
              if(this.flag1){
                this.$confirm({
                  title: '提示信息',
                  content: this.msg1,
                  cancelText:'取消',
                  okText:'确定',
                  onOk:()=>{
                    if(this.flag2) {
                      this.$confirm({
                        title: '提示信息',
                        content: this.msg2,
                        cancelText:'取消',
                        okText:'确定',
                        onOk:()=>{this.getCalculationResult()},
                        onCancel:()=>{this.flag2 = false,this.msg2 = ''}
                      });
                    }
                    else this.getCalculationResult()
                  },
                  onCancel:()=>{this.flag1 = false,this.msg1 = ''}
                });
              }
              else {
                if(this.flag2) {
                  this.$confirm({
                    title: '提示信息',
                    content: this.msg2,
                    cancelText:'取消',
                    okText:'确定',
                    onOk:()=>{this.getCalculationResult()},
                    onCancel:()=>{this.flag2 = false,this.msg2 = ''}
                  });
                }
                else this.getCalculationResult()
              }
            }
          }
        })
      }
      else if(this.current == 2){
        //保存数据
        this.$refs.newCustomerFeedback.form.validateFields((err) => {
          if (!err) {
            this.$refs.newCustomerFeedback.sendData()
            this.saveData()
          }
        })
        // this.current++;
      }
    },
    prev() {
      if(this.current == 1){
        this.$refs.newFeedInfo.form.validateFields((err, values) => {
          this.pigLineFeedInfo = values
          this.$refs.newFeedInfo.sendData()
        })
      }
      else if(this.current == 2){
        this.$refs.newCustomerFeedback.sendData()
      }
      this.current--;
    },
    setFeedInfo(value) {
      this.feedInfoList = value.feedInfoList
      this.feedStageList = value.feedStageList
      let into = this.feedInfoList[0]
      let out = this.feedInfoList[1]
      this.pigLineFeedInfo = {
        ...this.pigLineFeedInfo,
        intoDay:into.day,//.format('YYYY/MM/DD').replaceAll('/','-'),
        intoDayAge:into.dayAge,
        intoNum:into.num,
        avgInitialWeight:into.weight,
        outDay:out.day,//.format('YYYY/MM/DD').replaceAll('/','-'),
        outDayAge:out.dayAge,
        avgEndWeight:out.weight,
        outNum:out.num
      }
      this.pigLineRaiseInfos = this.feedStageList.filter(item => item.productName)
    },
    isShow(val){
      this.visible = val
    },
    setFactory(value) {
      this.factoryId = value.factoryId
      this.selectFactory = value.selectFactory
      this.settlementId = value.settlementId
      this.settlementName = value.settlementName
    },
    setFeedBack(value) {
      this.pigLineFeedBackReq = value
    },
    setFileList(value){
      this.fileList = value.fileList
      this.videoFileList =value.videoFileList
    },
    returnList(){
      this.$router.push({
        path: '/empirical-data/pig',
        query:{
          name: '猪线路',
        }
      })
    },
    feedCheck(){
      this.feedInfoList.forEach((el) => {
        if(!el.day || !el.num || !el.weight) {
          this.Tipsmsg = '请完善出入栏信息'
        }
      })
      let i = 0
      this.feedStageList.forEach((el) => {
        if(el.productName || el.productTarget || el.feedTerminalPrice || el.feedCost){
          if(!el.productName || !el.productTarget || !el.feedTerminalPrice || !el.feedCost) {
            this.Tipsmsg = '请完善饲养阶段信息'
          }
          i++
        }
      })
      if (i == 0) this.Tipsmsg = '请至少填写一条饲养阶段信息'
      if(this.Tipsmsg) {this.$message.error(this.Tipsmsg)}
      else{
        let obj = []
        let objCode = []
        const avgInitialWeight = this.pigLineFeedInfo.avgInitialWeight
        const avgEndWeight = this.pigLineFeedInfo.avgEndWeight
        let start = stagesLimitations.find(el => avgInitialWeight >= el.min && avgInitialWeight < el.max)
        let end = stagesLimitations.find(el => avgEndWeight > el.min && avgEndWeight <= el.max)
        stagesLimitations.forEach((el,index) => {
          if(index >= start.index && index <= end.index){
            obj.push(el.title)
            objCode.push(el.field)
          }
        })
        this.stages2 = obj
        this.stagesCode = objCode
        let checkList = this.feedStageList.filter(el => this.stagesCode.includes(el.stageType)) || []
        let noCheckList = this.feedStageList.filter(el => !this.stagesCode.includes(el.stageType)) || []
        let len = this.feedStageList.length - 1
        this.feedStageList.forEach((el,index) => {
          if(index < len){
            let next = this.feedStageList[index + 1]
            if((el.productTarget || el.productName) && (!next.productTarget && !next.productName)){
              let a = this.feedStageList.some((e,i) => (i > index + 1) && (e.productTarget || e.productName))
              let b = this.feedStageList.some((e,i) => (i > index + 1) && (e.feedTerminalPrice || e.feedCost))
              if(a || b){
                this.flag1 = true
                this.msg1 = '饲养阶段不连续，可能导致计算结果异常，请确认是否继续？'
              }
            }
          }
        })
        let c = checkList.filter(e => e.feedTerminalPrice || e.productName || e.feedCost || e.productTarget)
        let d = noCheckList.some(e => e.feedTerminalPrice || e.productName || e.feedCost || e.productTarget)
        if(c.length != checkList.length || d) {
          this.msg2 = '体重区间与饲养阶段存在不匹配，可能导致计算结果异常，请确认是否继续？'
          this.flag2 = true
        }
      }   
    },
    async getCalculationResult(){
      const res = await this.$http.post("/sat-collect/pigLine/calculate", { 
        pigLineFeedInfo:this.pigLineFeedInfo,
        pigLineRaiseInfos:this.pigLineRaiseInfos
      })
      let { msg,success,data } = res;
      if(data) this.calculationResult = data 
      if(!success) this.calculationAbnormal = msg.split(",")
      this.visible = true
    },
    calculationConfirm(){
      this.current++;
    },
    calculationAbnormalInit(){
      this.calculationAbnormal = []
    },
    async saveData(){
      let params = {
        pigLineCustomerInfo:{
          ...this.customerInfo,
          province:this.customerInfo.region ? this.customerInfo.region[0] : undefined,
          city:this.customerInfo.region ? this.customerInfo.region[1] : undefined,
          area:this.customerInfo.region ? this.customerInfo.region[2] : undefined,
          factoryId:this.factoryId,
          settlementId:this.settlementId,
          settlementName:this.settlementName,
        },
        pigLineFeedInfo:this.pigLineFeedInfo,
        pigLineRaiseInfos:this.pigLineRaiseInfos,
        pigLineProductResult:this.calculationResult,
        pigLineFeedBackReq:this.pigLineFeedBackReq
      }
      const res = await this.$http.post("/sat-collect/pigLine/save", params)
      this.saveSuccess = res.success
      if(res.success) this.recordId = res.data.pigLineCustomerInfo.id
      this.current++
    },
    loadFiles() {
      this.fileList = []
      this.videoFileList = []
      this.pigLineFeedBackReq.uploadFiles?.forEach(item => {
        const fileName = item.fileName
        const arr = fileName.split("/")
        const name = arr[arr.length-1]
        this.$http.get('/sat-collect/upload/getFileUrlList',{ params:{fileName} }).then(res =>{
          if(item.mediaType == 'PIC'){
            this.fileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
          if(item.mediaType == 'VIDEO'){
            this.videoFileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
        })
      })
    }
  },
};
</script>

<style lang='scss'>
.newDataPage{
  background-color: #fff;
  margin-top: 20px;
  .ant-form-item-label{
    line-height: 20px;
  }
  .ant-form-explain{
    margin-top: -2px;
  }
}
.steps{
  padding: 30px;
}
.footer{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 8px;
  background: #fff;
  text-align: center;
  z-index: 1;
  .ant-btn{
    font-size: small !important
  }
}
</style>